import { Box, MenuList, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  title?: string;
}

const VerticalNavigationSection = ({ title, children }: PropsWithChildren<Props>) => (
  <Box sx={{ pl: title ? 1 : 0 }}>
    {title && <Typography variant="subtitle2">{title}</Typography>}
    <MenuList>{children}</MenuList>
  </Box>
);

export default VerticalNavigationSection;
